import { ref, computed, watch, watchEffect } from 'vue';
import { defineStore } from 'pinia';

export const useModal = defineStore('formychat_modal', () => {
    const options = ref({
        title: 'Hello World',
        message: 'This is a message',
        cancel: 'Cancel',
        ok: 'OK',
        outsideClick: true,
        escClose: true,
        close: true,
        cancelColor: "secondary",
        okColor: "primary",
    });

    const open = ref(false);
    const resolved = ref(null);

    const getOptions = computed(() => options.value);
    const isOpen = computed(() => open.value);

    const show = (_options) => {
        resolved.value = null;
        options.value = { ...options.value, ..._options };
        open.value = true;
    };

    const close = () => {
        open.value = false;
    };

    const ok = () => {
        resolved.value = { ok: true, cancel: false };
        close();
    };

    const cancel = () => {
        resolved.value = { ok: false, cancel: true };
        close();
    };

    const fire = (_options = null) => {

        close();
        show(_options);

        return new Promise((resolve) => {

            const interval = setInterval(() => {

                if (resolved.value !== null) {
                    clearInterval(interval);
                    resolve(resolved.value);
                    resolved.value = null;
                }

                if (open.value === false) {
                    clearInterval(interval);
                    resolve({ ok: false, cancel: false, close: true });
                    resolved.value = null;
                }
            }, 100);
            
        });
    };

    const prompt = async ( _options ) => {
       let options = {
        ok: 'Yes, delete!',
        cancel: 'Cancel',
        okColor: "danger",
        ..._options,
       }

        return await fire(options);
    };

    return {
        getOptions,
        isOpen,
        show,
        close,
        ok,
        cancel,
        fire,
        prompt,
    };
});
